import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SeoService } from '@geekeno/ngx-website/services';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { ContactFormService } from './contact-form/contact-form.service';
import { ContactFormComponent } from './contact-form/contact-form.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NavbarComponent,
    FooterComponent,
    ContactFormComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private contactFormService = inject(ContactFormService);
  private seo = inject(SeoService); // needed to load SEO data from routes

  contactFormSource = 'unknown';

  showContactForm = false;

  ngOnInit() {
    this.contactFormService.openForm$.subscribe((source: string) => {
      this.showContactForm = true;
      this.contactFormSource = source;
    });
  }

  closeContactForm() {
    this.showContactForm = false;
  }
}
